import { getTeacherRemarksMockHandler } from '@/features/module-reports/api';

export const moduleReportsHandlers = [getTeacherRemarksMockHandler];
